import * as React from "react";
export const TicketWarningIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={86.971} height={78.059} viewBox="0 0 86.971 78.059" {...props}>
      <g transform="translate(-0.093 -26.315)">
        <path
          d="M85.692,89.028,52.438,31.43a10.23,10.23,0,0,0-17.72,0L1.464,89.028a10.23,10.23,0,0,0,8.86,15.346H76.833a10.23,10.23,0,0,0,8.86-15.345ZM81.278,96.71a5.081,5.081,0,0,1-4.446,2.566H10.324a5.133,5.133,0,0,1-4.446-7.7l33.255-57.6a5.133,5.133,0,0,1,8.891,0l33.255,57.6A5.081,5.081,0,0,1,81.278,96.71Z"
          fill="#252525"
        />
        <rect
          width={5.097}
          height={25.486}
          transform="translate(41.029 51.752)"
          fill="#252525"
        />
        <path
          d="M239.4,355.99a3.4,3.4,0,1,0,3.4,3.4,3.4,3.4,0,0,0-3.4-3.4Z"
          transform="translate(-195.82 -273.655)"
          fill="#252525"
        />
      </g>
    </svg>
  );
};
